export function getPaymentMethod(key) {
    switch (key) {
        case "1":
            return paymentMethods.googlePay;
        case "2":
            return paymentMethods.applePay;
        default:
            return paymentMethods.creditCard;
    }
}

export const paymentMethods = {
    creditCard: "Credit Card",
    googlePay: "Google Pay",
    applePay: "Apple Pay"
};